import React from "react";
import Herosection from "../components/page-components/home/Herosection";
import ServiceSection from "../components/page-components/home/ServiceSection";
import ToolsSection from "../components/page-components/home/ToolsSection";
import ProjectSection from "../components/page-components/home/ProjectSection";
import TeamSection from "../components/page-components/home/TeamSection";
import AboutSection from "../components/page-components/home/AboutSection";
import WhyChooseUs from "../components/page-components/home/WhyChooseUs";
import TestimonialSection from "../components/page-components/home/TestimonialSection";
import BlogSection from "../components/page-components/home/BlogSection";
import InternshipSection from "../components/page-components/home/IntershipSection";
import Footer from "../components/Footer";
import TruestSection from "../components/page-components/home/TruestSection";
import { Helmet } from "react-helmet-async";
const Home = () => {
  return (
    <>
      <Helmet>
        <title>
          Web X Secure | Website Development, SEO, Digital Marketing & Cyber
          Security Company
        </title>

        <meta
          name="description"
          content="Web X Secure provides website development, web applications, SEO, digital marketing, cybersecurity, SaaS development and business automation solutions for startups and businesses."
        />

        <meta
          name="keywords"
          content="Web Development Company, Website Development, SEO Services, Digital Marketing Agency, Cyber Security Company, SaaS Development, Web X Secure"
        />

        <meta name="robots" content="index, follow" />

        <meta name="author" content="Web X Secure" />

        <link rel="canonical" href="https://webxsecure.in/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Web X Secure | Website Development, SEO & Digital Marketing Company"
        />

        <meta
          property="og:description"
          content="Professional website development, SEO, digital marketing, cybersecurity and SaaS development solutions for businesses."
        />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta property="og:url" content="https://webxsecure.in" />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Web X Secure" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Web X Secure | Website Development, SEO & Digital Marketing Company"
        />

        <meta
          name="twitter:description"
          content="Professional website development, SEO, digital marketing, cybersecurity and SaaS development solutions."
        />

        <meta name="twitter:image" content="https://webxsecure.in/logo.png" />

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Web X Secure",
            url: "https://webxsecure.in",
            logo: "https://webxsecure.in/logo.png",
            description:
              "Website Development, SEO, Digital Marketing and Cyber Security Company",
            foundingDate: "2022",
            founder: {
              "@type": "Person",
              name: "Rohit Bhardwaj",
            },
            sameAs: [
              "https://www.linkedin.com/company/webxsecure",
              "https://www.instagram.com/webxsecure",
            ],
          })}
        </script>

        {/* Website Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Web X Secure",
            url: "https://webxsecure.in",
          })}
        </script>

        {/* Local Business Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Web X Secure",
            url: "https://webxsecure.in",
            image: "https://webxsecure.in/logo.png",
            address: {
              "@type": "PostalAddress",
              addressRegion: "Rajasthan",
              addressCountry: "IN",
            },
            priceRange: "₹₹",
          })}
        </script>

        {/* Breadcrumb */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
            ],
          })}
        </script>
      </Helmet>
      <div>
        <Herosection />
        <ServiceSection />
        <AboutSection />
        <WhyChooseUs />
        <ProjectSection />
        <TestimonialSection />
        <BlogSection />
        <ToolsSection />
        <InternshipSection />
        <TruestSection />
      </div>
    </>
  );
};

export default Home;
